import { Button } from './Button.types';
import { ButtonTypes } from 'src/lib/constants';
/* eslint-disable import/prefer-default-export */

/**
 *
 * An adapter allows two incompatible interfaces to work together.
 * This is the real-world definition for an adapter. Interfaces may be incompatible,
 * but the inner functionality should suit the need. The adapter design pattern allows
 * otherwise incompatible classes to work together by converting the interface of one
 * class into an interface expected by the clients.
 *
 * Convert the interface of a class into another interface clients expect.
 * Adapter lets classes work together that couldn’t otherwise because of incompatible
 * interfaces.
 */

interface AdapterProps {
  type: string;
  url: string;
}

export const buttonAdapter = ({ type, url }: AdapterProps): Button => {
  return {
    secondary: type === ButtonTypes.SECONDARY_CTA,
    href: url,
  };
};
